const COOKIE_NAME = 'product_viewed_today';
const MAX_LIMIT = 20;

class ProductsViewedTodayTable extends HTMLElement {
    constructor() {
        super();
        this.hasCheckbox = this.getAttribute("has-checkbox");
        this.locale = this.getAttribute("locale");

        this.customerId = window.GLOBAL.customerId;
        this.selectedItems = [];
        this.products = [];
        this.productViewedToday = [];

        this.empty = this.dataset.empty
        this.deleteConfirm = this.dataset.deleteConfirm
        this.deleteBtnLabel = this.dataset.deleteButtonLabel;
        this.setup()

    }

    setup() {
        window.addEventListener("load", async () => {
            // console.log(this)

            this.productViewedToday = getProductsViewedToday();

            if (!this.productViewedToday.length) {
                this.renderNoData()
                return;
            }

            let response = await getProductsByIds(
                this.productViewedToday,
                `
                    title
                    handle
                    featuredImage { url }
                    priceRange{ 
                        maxVariantPrice { amount } 
                        minVariantPrice { amount } 
                    }
                `
            );

            if (response.result) {
                let products = response.data;
                this.loadTable(products);
            }
        });
    }

    loadTable(data){
        const paginationList = document.querySelector(".js-pagination-list")

        this.table = new Table(this.querySelector('table'), {
            rowData: data,
            columnDefs: [
                {
                    field: "image",
                    className: "thumbnail cell-left",
                    cellRender: (data) => {
                        let url = data?.featuredImage?.url || '';
                        let handle = data.handle;

                        return `<a href="/products/${handle}">
                        <img src="${url}" alt="">
                        </a>`
                    }
                },
                {
                    field: "title",
                    cellRender: (data) => {
                        // let localeTitle = data.translations.find((e) => e.key === "title")?.value;
                        let title = data.title;
                        let handle = data.handle;

                        return `<a style="text-decoration: none; color: black;" href="/products/${handle}">
                        ${title}
                        </a>`;
                    }
                },
                {
                    field: "price",
                    className:"price cell-right",
                    cellRender: (data) => {
                        let price = data?.priceRange?.maxVariantPrice?.amount || 0;
                        const formatter = new Intl.NumberFormat()
                        let formatted = formatter.format(Math.trunc(price))
                        return `${formatted} 원`
                    }
                },
                {
                    field: "order",
                    className:"cell-center",
                    cellRender: (data) => {
                        let id = this.getRowId(data);
                        let deleteBtn = document.createElement('button');

                        deleteBtn.id = "delete-btn"
                        deleteBtn.className = "btn-normal";
                        deleteBtn.innerText = this.deleteBtnLabel;
                        deleteBtn.addEventListener('click', this.handleDelete.bind(this, { id }));

                        return deleteBtn;
                    }
                }
            ],
            checkboxSelection: false,
            rowIdField: 'id', 
            getRowId: this.getRowId,
            // setRowNode: ({data, node}) => {
            //     node.setAttribute('data-handle', data.handle)
            // },
            paginationList,
            pagination: true,
            paginationPageSize: 10,
            emptyText: this.empty,
            // maxHeight: '300px'
            
        });
    }

    getRowId(data) {
        return data.id.split('gid://shopify/Product/')[1]
    }

    renderNoData() {
        this.innerHTML = `
        <div class="message">
            ${this.empty}
        </div>
        `
        document.querySelector(".js-pagination-list").style = 'display: none'

    }

    handleDelete({ id }, event){
        if(confirm(this.deleteConfirm)){
            this.table.deleteRow(id);
            // let parentNode = event.target.closest('tr');
            // let item = this.productViewedToday.find((handle) => handle === parentNode.dataset.handle);
            // this.selectedItems = this.selectedItems.filter((e) => e !== item);
            deleteProductsViewedToday(id)
            // parentNode.remove();
            // this.refresh()
        }
    }

    // refresh(){
    //     this.productViewedToday = getProductsViewedToday();
    //     if (!this.productViewedToday.length) {
    //         this.renderNoData()
    //     }
    // }

}

customElements.define("product-viewed-today-table", ProductsViewedTodayTable);



function setProductsViewedToday(handle){
    if(handle){
        let productsViewedToday = getProductsViewedToday();
        const EXPIRE_TIME = new Date(new Date().setUTCHours(23,59,59,999)).toUTCString()
    
        productsViewedToday = productsViewedToday.filter((h) => h !== handle)
    
        productsViewedToday.unshift(handle)
      
        // const newCookieValue = recentlyViewed.slice(0, MAX_LIMIT).join('|')
        const newCookieValue = productsViewedToday.join(',')
      
        Cookies().set(COOKIE_NAME, newCookieValue, { expiresIn: EXPIRE_TIME })
    }
}

function getProductsViewedToday(){
    const cookie = Cookies().get(COOKIE_NAME)
    const handles = cookie?.length ? cookie.split(",") : [];
    // console.log(cookie)
    return handles;
}

function deleteProductsViewedToday(handle){
    let productsViewedToday = getProductsViewedToday();
    const EXPIRE_TIME = new Date(new Date().setUTCHours(23,59,59,999)).toUTCString()

    productsViewedToday = productsViewedToday.filter((h) => h !== handle);
    productsViewedToday = productsViewedToday.filter((e) => e);

    const newCookieValue = productsViewedToday.join(',')
  
    Cookies().set(COOKIE_NAME, newCookieValue, { expiresIn: EXPIRE_TIME })
}